import { render, staticRenderFns } from "./PollViewer.vue?vue&type=template&id=b79cf4a6&scoped=true"
import script from "./PollViewer.vue?vue&type=script&lang=js"
export * from "./PollViewer.vue?vue&type=script&lang=js"
import style0 from "./PollViewer.vue?vue&type=style&index=0&id=b79cf4a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79cf4a6",
  null
  
)

export default component.exports